import { useState, useCallback } from 'react';
import { fetchContactsByClient, fetchOrgContacts as fetchOrgContactsService } from '../services/contacts.service';

export interface SchedulerContact {
  _id: string;
  name: string;
  email?: string;
  isPrimary?: boolean;
}

interface MeetingSchedulerDataState {
  linkedContacts: SchedulerContact[];
  isContactsLoading: boolean;
  fetchContactsForClient: (clientId: string) => Promise<SchedulerContact[]>;
  fetchOrgContacts: () => Promise<SchedulerContact[]>;
}

export const useMeetingSchedulerData = (orgId?: string): MeetingSchedulerDataState => {
  const [linkedContacts, setLinkedContacts] = useState<SchedulerContact[]>([]);
  const [isContactsLoading, setIsContactsLoading] = useState(false);

  const fetchContactsForClient = useCallback(async (clientId: string): Promise<SchedulerContact[]> => {
    if (!clientId) {
      setLinkedContacts([]);
      return [];
    }
    setIsContactsLoading(true);
    try {
      const response: any = await fetchContactsByClient(clientId);
      const fetched: SchedulerContact[] = response.data || [];
      setLinkedContacts(fetched);
      return fetched;
    } catch {
      setLinkedContacts([]);
      return [];
    } finally {
      setIsContactsLoading(false);
    }
  }, []);

  const fetchOrgContacts = useCallback(async (): Promise<SchedulerContact[]> => {
    if (!orgId) return [];
    try {
      const res: any = await fetchOrgContactsService(orgId);
      return res?.contacts || res?.data || [];
    } catch {
      return [];
    }
  }, [orgId]);

  return { linkedContacts, isContactsLoading, fetchContactsForClient, fetchOrgContacts };
};
